import DeleteConfirmation from "./DeleteConfirmation";
export default DeleteConfirmation;